import * as i from "react";
import { jsx as f, Fragment as P } from "react/jsx-runtime";
import * as g from "react-dom";
function x(e, t) {
  if (typeof e == "function")
    return e(t);
  e != null && (e.current = t);
}
function y(...e) {
  return (t) => {
    let r = !1;
    const s = e.map((n) => {
      const o = x(n, t);
      return !r && typeof o == "function" && (r = !0), o;
    });
    if (r)
      return () => {
        for (let n = 0; n < s.length; n++) {
          const o = s[n];
          typeof o == "function" ? o() : x(e[n], null);
        }
      };
  };
}
function D(...e) {
  return i.useCallback(y(...e), e);
}
function I(e, t) {
  const r = i.createContext(t), s = (o) => {
    const { children: c, ...u } = o, l = i.useMemo(() => u, Object.values(u));
    return /* @__PURE__ */ f(r.Provider, { value: l, children: c });
  };
  s.displayName = e + "Provider";
  function n(o) {
    const c = i.useContext(r);
    if (c) return c;
    if (t !== void 0) return t;
    throw new Error(`\`${o}\` must be used within \`${e}\``);
  }
  return [s, n];
}
function V(e, t = []) {
  let r = [];
  function s(o, c) {
    const u = i.createContext(c), l = r.length;
    r = [...r, c];
    const a = (p) => {
      const { scope: C, children: v, ...d } = p, h = C?.[e]?.[l] || u, b = i.useMemo(() => d, Object.values(d));
      return /* @__PURE__ */ f(h.Provider, { value: b, children: v });
    };
    a.displayName = o + "Provider";
    function m(p, C) {
      const v = C?.[e]?.[l] || u, d = i.useContext(v);
      if (d) return d;
      if (c !== void 0) return c;
      throw new Error(`\`${p}\` must be used within \`${o}\``);
    }
    return [a, m];
  }
  const n = () => {
    const o = r.map((c) => i.createContext(c));
    return function(u) {
      const l = u?.[e] || o;
      return i.useMemo(
        () => ({ [`__scope${e}`]: { ...u, [e]: l } }),
        [u, l]
      );
    };
  };
  return n.scopeName = e, [s, E(n, ...t)];
}
function E(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const r = () => {
    const s = e.map((n) => ({
      useScope: n(),
      scopeName: n.scopeName
    }));
    return function(o) {
      const c = s.reduce((u, { useScope: l, scopeName: a }) => {
        const p = l(o)[`__scope${a}`];
        return { ...u, ...p };
      }, {});
      return i.useMemo(() => ({ [`__scope${t.scopeName}`]: c }), [c]);
    };
  };
  return r.scopeName = t.scopeName, r;
}
// @__NO_SIDE_EFFECTS__
function w(e) {
  const t = /* @__PURE__ */ R(e), r = i.forwardRef((s, n) => {
    const { children: o, ...c } = s, u = i.Children.toArray(o), l = u.find(_);
    if (l) {
      const a = l.props.children, m = u.map((p) => p === l ? i.Children.count(a) > 1 ? i.Children.only(null) : i.isValidElement(a) ? a.props.children : null : p);
      return /* @__PURE__ */ f(t, { ...c, ref: n, children: i.isValidElement(a) ? i.cloneElement(a, void 0, m) : null });
    }
    return /* @__PURE__ */ f(t, { ...c, ref: n, children: o });
  });
  return r.displayName = `${e}.Slot`, r;
}
// @__NO_SIDE_EFFECTS__
function R(e) {
  const t = i.forwardRef((r, s) => {
    const { children: n, ...o } = r;
    if (i.isValidElement(n)) {
      const c = N(n), u = $(o, n.props);
      return n.type !== i.Fragment && (u.ref = s ? y(s, c) : c), i.cloneElement(n, u);
    }
    return i.Children.count(n) > 1 ? i.Children.only(null) : null;
  });
  return t.displayName = `${e}.SlotClone`, t;
}
var S = Symbol("radix.slottable");
// @__NO_SIDE_EFFECTS__
function M(e) {
  const t = ({ children: r }) => /* @__PURE__ */ f(P, { children: r });
  return t.displayName = `${e}.Slottable`, t.__radixId = S, t;
}
function _(e) {
  return i.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === S;
}
function $(e, t) {
  const r = { ...t };
  for (const s in t) {
    const n = e[s], o = t[s];
    /^on[A-Z]/.test(s) ? n && o ? r[s] = (...u) => {
      const l = o(...u);
      return n(...u), l;
    } : n && (r[s] = n) : s === "style" ? r[s] = { ...n, ...o } : s === "className" && (r[s] = [n, o].filter(Boolean).join(" "));
  }
  return { ...e, ...r };
}
function N(e) {
  let t = Object.getOwnPropertyDescriptor(e.props, "ref")?.get, r = t && "isReactWarning" in t && t.isReactWarning;
  return r ? e.ref : (t = Object.getOwnPropertyDescriptor(e, "ref")?.get, r = t && "isReactWarning" in t && t.isReactWarning, r ? e.props.ref : e.props.ref || e.ref);
}
var O = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], W = O.reduce((e, t) => {
  const r = /* @__PURE__ */ w(`Primitive.${t}`), s = i.forwardRef((n, o) => {
    const { asChild: c, ...u } = n, l = c ? r : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ f(l, { ...u, ref: o });
  });
  return s.displayName = `Primitive.${t}`, { ...e, [t]: s };
}, {});
function A(e, t) {
  e && g.flushSync(() => e.dispatchEvent(t));
}
export {
  W as P,
  w as a,
  I as b,
  V as c,
  A as d,
  y as e,
  M as f,
  D as u
};
